/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import React from 'react';
import { amountComparator } from '../../../../SharedModules/utilities/utilities';
const comparator = (a, b) => {
  return new Date(a) - new Date(b);
};


const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};


export const RequestQuarterlyClaimReconciliationTableHead = [
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    comparator: comparatorQtr,
    cellStyle: { borderRightColor: Styles.BorderColor },

    sortable: true,
    maxWidth: Styles.Width_180,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Requestor User Id',
    field: 'requestorUserId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_400,
    cellStyle: { borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Request Date',
    field: 'requestDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator,
    cellStyle: { borderRightColor: Styles.BorderColor },
    minWidth: Styles.Width_150,
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const rightHead = [
  {
    headerName: 'Load Date',
    field: 'claimLoadDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator,
    cellRenderer: (params) => {
      if (params?.data?.head) {
        return <b>{params.value}</b>;
      }
      return params.value;
    },
    minWidth: Styles.Width_200,
    cellStyle: { borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Count',
    field: 'recordCount',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    excelAlignment: 'right',
    isTextColorRed: true,
    comparator: amountComparator,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const leftHead = [
  {
    headerName: ' ',
    field: 'title',
    editable: false,
    suppressMenu: false,
    sortable: false,
    cellRenderer: (params) => {
      if (params?.data?.head) {
        return <b>{params.value}</b>;
      }
      return params.value;
    },
    minWidth: Styles.Width_200,
    cellStyle: { borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    filter: false,
  },
  {
    headerName: ' ',
    field: 'recordCount',
    filter: false,
    editable: false,
    suppressMenu: false,
    excelAlignment: 'right',
    isTextColorRed: true,
    comparator: amountComparator,

    sortable: false,
    maxWidth: Styles.Width_150,
    type: 'numericColumn',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },

    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
  },
];
